module.exports = __webpack_public_path__ + "img/today-question-banner.58fd883e.png";